import React, { useCallback, useEffect, useState } from 'react';
import { IWorkflowStep } from '@modules/admin/AdminTools/Workflows/types';
import { sortSteps } from '@modules/admin/AdminTools/Workflows/utils';
import { Header, WorkflowLevelWrapper } from '@styles/Admin-tools/Workflows/WorkflowStepStyles';
import { DealsButton } from '@styles/StyledButtons';
import Step from '../../../Step/Step';

type TWorkflowLevelProps = {
  order: number;
  handleAddStepButtonClick: (id: string) => void;
  steps: IWorkflowStep[] | null;
  handleSelectStep: (data: IWorkflowStep) => void;
  handleAddStep: (id: string) => void;
  handleEditParentStep: (id: string | null, parentStepId: string | null) => void;
  parentStepId: string | null;
  setWorkflowLevel: React.Dispatch<React.SetStateAction<boolean>>;
};

const DEFAULT_LEVEL = 1;

const WorkflowLevel = ({
  handleSelectStep,
  handleAddStep,
  order,
  handleEditParentStep,
  handleAddStepButtonClick,
  steps,
  parentStepId,
  setWorkflowLevel,
}: TWorkflowLevelProps) => {
  const [currentStep, setCurrentStep] = useState<IWorkflowStep | null>(null);
  const [nextStepsList, setNextStepsList] = useState<IWorkflowStep[] | null>(null);

  useEffect(() => {
    setCurrentStep(null);
    setNextStepsList(null);
  }, [steps]);

  useEffect(() => {
    if (currentStep?.childSteps?.length) {
      setNextStepsList(sortSteps(currentStep.childSteps));
    } else {
      setNextStepsList(null);
    }
  }, [currentStep]);

  const onStepClick = useCallback((item: IWorkflowStep) => {
    setCurrentStep(item);
    setWorkflowLevel(false);
  }, []);

  const handleAddButtonClick = useCallback(() => {
    parentStepId && handleAddStepButtonClick(parentStepId);
    setWorkflowLevel(order === DEFAULT_LEVEL);
  }, [parentStepId, order]);

  return (
    <>
      <WorkflowLevelWrapper>
        <Header>
          Workflow Level {order} {currentStep?.stepType === 'Fork' ? '- Fork' : ''}
        </Header>

        {steps &&
          steps.map((item) => (
            <Step
              key={item.id}
              handleEditParentStep={handleEditParentStep}
              handleOnStepClick={() => onStepClick(item)}
              handleAddStep={handleAddStep}
              handleEditStep={handleSelectStep}
              stepData={item}
              isChecked={item === currentStep}
            />
          ))}

        {parentStepId && (
          <DealsButton onClick={handleAddButtonClick}>
            + Add step
          </DealsButton>
        )}
      </WorkflowLevelWrapper>

      {currentStep && nextStepsList && (
        <WorkflowLevel
          handleEditParentStep={handleEditParentStep}
          order={order + 1}
          setWorkflowLevel={setWorkflowLevel}
          handleSelectStep={handleSelectStep}
          handleAddStep={handleAddStep}
          handleAddStepButtonClick={handleAddStepButtonClick}
          steps={nextStepsList}
          parentStepId={currentStep.id}
        />
      )}
    </>
  );
};

export default WorkflowLevel;
